import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostRendererComponent } from './post-renderer.component';

const routes: Routes = [
  // {
  //   path: 'posts/:uniq',
  //   component: PostRendererComponent,
  // },
  {
    path: 'posts',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'rentals',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'boat-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'party-yacht-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'party-boat-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'mega-yacht-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'pontoon-boat-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'luxury-yacht-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'catamaran-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'sailboat-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'yacht-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'yacht-charter',
    children: [{ path: '**', component: PostRendererComponent }],
  },
  {
    path: 'yacht-charter-and-yacht-rental',
    children: [{ path: '**', component: PostRendererComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostRendererRoutingModule {}
